import { buildDateTime } from 'lib/CustomLuxonUtils'
import ErrorOutlineOutlinedIcon from 'components/material-symbol/icons/ErrorOutline'
import Chip from '@material-ui/core/Chip'

export const validateSessionOverlap = value => {
  if (!Array.isArray(value) || value.length === 0) {
    return true
  }

  const conflicts = value.some((current, idx, arr) => {
    const { startDate, startTime, endTime } = current
    const startDateTime = buildDateTime(startDate, startTime)
    const endDateTime = buildDateTime(startDate, endTime)
    return arr.slice(idx + 1).some(test => {
      const testStartDateTime = buildDateTime(test.startDate, test.startTime)
      const testEndDateTime = buildDateTime(test.startDate, test.endTime)
      return (
        (startDateTime >= testStartDateTime &&
          endDateTime <= testEndDateTime) ||
        (startDateTime < testEndDateTime && endDateTime >= testEndDateTime) ||
        (endDateTime > testStartDateTime && endDateTime <= testEndDateTime)
      )
    })
  })
  return !conflicts
}

export const getPaymentAccountWarningChip = ({
  event,
  classes,
  isMobile = false,
}) => {
  const {
    paymentAccount,
    priceInCents,
    acceptsOnlinePayments,
    lessonPacks,
    isPast,
  } = event
  const { deletedAt, chargesEnabled, payoutsEnabled } = paymentAccount || {}
  const isPaymentRequired =
    (paymentAccount && acceptsOnlinePayments && priceInCents > 0) ||
    lessonPacks?.length > 0

  if (!isPaymentRequired || (typeof isPast === 'function' && isPast())) {
    return null
  }
  if (deletedAt || !chargesEnabled) {
    return (
      <Chip
        label="Unable to Accept Payments"
        className={classes.unableToAcceptPaymentsChip}
        icon={<ErrorOutlineOutlinedIcon className={classes.errorIcon} />}
        size={isMobile ? 'small' : 'medium'}
      />
    )
  }
  if (!payoutsEnabled) {
    return (
      <Chip
        label="Payouts on Hold"
        className={classes.payoutsOnHoldChip}
        icon={<ErrorOutlineOutlinedIcon className={classes.errorIcon} />}
        size={isMobile ? 'small' : 'medium'}
      />
    )
  }
  return null
}
